import { z } from "zod"
import { nullableToOptional } from "../common/zod-utils"
import { TranslationKey } from "../i18n/translation-key"

export const CustomerClubSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  linkToInfo: z.string().nullable(),
  storeId: z.string().uuid(),
})

export const CreateCustomerClubSchema = nullableToOptional(
  CustomerClubSchema.omit({ id: true }),
)
export const UpdateCustomerClubSchema = CreateCustomerClubSchema.partial()

export type CustomerClub = z.infer<typeof CustomerClubSchema>
export type CreateCustomerClub = z.infer<typeof CreateCustomerClubSchema>
export type UpdateCustomerClub = z.infer<typeof UpdateCustomerClubSchema>

// An empty link clears it, so customers aren't shown a "read more" link
export const SaveCustomerClubSettingsSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "common.validation.nameRequired" satisfies TranslationKey)
    .max(255),
  linkToInfo: z
    .string()
    .trim()
    .max(255)
    .url("common.validation.invalidUrl" satisfies TranslationKey)
    .or(z.literal("")),
})
export type SaveCustomerClubSettings = z.infer<
  typeof SaveCustomerClubSettingsSchema
>

export const CustomerClubMemberSchema = z.object({
  id: z.string().uuid(),
  firstName: z.string(),
  lastName: z.string().nullable(),
  phoneNumber: z.string(),
  email: z.string().nullable(),
  joinedClubAt: z.coerce.date(),
})
export type CustomerClubMember = z.infer<typeof CustomerClubMemberSchema>

export const CustomerClubImportSkippedRowSchema = z.object({
  /** 1-based row number in the file, counting the header row */
  row: z.number(),
  reason: z.string(),
})
export type CustomerClubImportSkippedRow = z.infer<
  typeof CustomerClubImportSkippedRowSchema
>

export const CustomerClubImportResultSchema = z.object({
  /** Customers that didn't exist in the store before the import */
  created: z.number(),
  /** Existing customers that weren't members before the import */
  joined: z.number(),
  alreadyMembers: z.number(),
  skipped: z.array(CustomerClubImportSkippedRowSchema),
})
export type CustomerClubImportResult = z.infer<
  typeof CustomerClubImportResultSchema
>
